import {
  FETCH_CONTRACT_LOADING,
  FETCH_CONTRACT_DONE,
  FETCH_CONTRACT_ERROR,

  FETCH_CONTRACT_FILTER_LOADING,
  FETCH_CONTRACT_FILTER_DONE,
  FETCH_CONTRACT_FILTER_ERROR,
  // fetch by id
  FETCH_CONTRACT_BY_ID_LOADING,
  FETCH_CONTRACT_BY_ID_DONE,
  FETCH_CONTRACT_BY_ID_ERROR,
  // fetch bid
  FETCH_BID_CONTRACT_LOADING,
  FETCH_BID_CONTRACT_DONE,
  FETCH_BID_CONTRACT_ERROR,
  // create one
  CREATE_CONTRACT_LOADING,
  CREATE_CONTRACT_DONE,
  CREATE_CONTRACT_ERROR,
  // fetch bid
  FETCH_BID_PRICE_LOADING,
  FETCH_BID_PRICE_DONE,
  FETCH_BID_PRICE_ERROR,
  // cancel contract
  CANCEL_CONTRACT_LOADING,
  CANCEL_CONTRACT_DONE,
  CANCEL_CONTRACT_ERROR,
  // get contract details
  GET_CONTRACT_DETAIL_LOADING,
  GET_CONTRACT_DETAIL_DONE,
  GET_CONTRACT_DETAIL_ERROR,
  // get shipment on going
  GET_SHIPMENT_ONGOING_LOADING,
  GET_SHIPMENT_ONGOING_DONE,
  GET_SHIPMENT_ONGOING_ERROR,
  // EXTEND CONTRACT
  EXTEND_CONTRACT_LOADING,
  EXTEND_CONTRACT_DONE,
  EXTEND_CONTRACT_ERROR,
  // get business agreement
  GET_BUSINESS_AGREEMENT_LOADING,
  GET_BUSINESS_AGREEMENT_DONE,
  GET_BUSINESS_AGREEMENT_ERROR,
  // accept business agreement
  ACCEPT_BUSINESS_AGREEMENT_LOADING,
  ACCEPT_BUSINESS_AGREEMENT_DONE,
  ACCEPT_BUSINESS_AGREEMENT_ERROR,
  // download business agreement
  DOWNLOAD_BUSINESS_AGREEMENT_LOADING,
  DOWNLOAD_BUSINESS_AGREEMENT_DONE,
  DOWNLOAD_BUSINESS_AGREEMENT_ERROR,
  // show agreement
  SHOW_AGREEMENT_CTC_LOADING,
  SHOW_AGREEMENT_CTC_DONE,
  SHOW_AGREEMENT_CTC_ERROR

} from './actions'

export default {
  [FETCH_CONTRACT_LOADING] (state) {
    state.isLoading = true
    state.itemExtend = false
  },

  [FETCH_CONTRACT_DONE] (state, items) {
    state.items = items
    state.isLoading = false
  },

  [FETCH_CONTRACT_ERROR] (state, error) {
    state.error = error
    state.isLoading = false
  },

  [FETCH_CONTRACT_FILTER_LOADING] (state) {
    state.isLoadingContractFilter = true
  },

  [FETCH_CONTRACT_FILTER_DONE] (state, items) {
    state.contractFilter = items
    state.isLoadingContractFilter = false
  },

  [FETCH_CONTRACT_FILTER_ERROR] (state, error) {
    state.errorContractFilter = error
    state.isLoadingContractFilter = false
  },

  [FETCH_CONTRACT_BY_ID_LOADING] (state) {
    state.item = {}
    state.isLoading = true
    state.error = false
  },

  [FETCH_CONTRACT_BY_ID_DONE] (state, items) {
    state.item = items
    state.isLoading = false
    state.error = false
  },

  [FETCH_CONTRACT_BY_ID_ERROR] (state, error) {
    state.item = {}
    state.error = true
    state.isLoading = false
  },

  [FETCH_BID_CONTRACT_LOADING] (state) {
    state.isLoadingBid = true
    state.errorBid = false
  },

  [FETCH_BID_CONTRACT_DONE] (state, items) {
    state.bids = items
    state.isLoadingBid = false
    state.errorBid = false
  },

  [FETCH_BID_CONTRACT_ERROR] (state, error) {
    state.errorBid = true
    state.isLoadingBid = false
    state.bids = []
  },

  [CREATE_CONTRACT_LOADING] (state) {
    state.isLoading = true
  },

  [CREATE_CONTRACT_DONE] (state, item) {
    state.obj = item
    state.isLoading = false
  },

  [CREATE_CONTRACT_ERROR] (state, error) {
    state.error = error.data
    state.isLoading = false
  },

  [FETCH_BID_PRICE_LOADING] (state) {
    state.isLoadingBidPrice = true
    state.isErrorLoadingBidPrice = false
  },

  [FETCH_BID_PRICE_DONE] (state, items) {
    state.bidPrice = items
    state.isLoadingBidPrice = false
    state.isErrorLoadingBidPrice = false
  },

  [FETCH_BID_PRICE_ERROR] (state, error) {
    state.isErrorLoadingBidPrice = true
    state.isLoadingBidPrice = false
    state.bidPrice = []
  },

  [CANCEL_CONTRACT_LOADING] (state) {
    state.isLoadingCancel = true
  },

  [CANCEL_CONTRACT_DONE] (state, itemCancel) {
    state.itemCancel = itemCancel
    state.isLoadingCancel = false
  },

  [CANCEL_CONTRACT_ERROR] (state, error) {
    state.itemCancel = {}
    state.errorCancel = true
    state.isLoadingCancel = false
  },

  [GET_CONTRACT_DETAIL_LOADING] (state) {
    state.isLoadingDetails = true
    state.isErrorDetails = false
  },

  [GET_CONTRACT_DETAIL_DONE] (state, details) {
    state.details = details
    state.isLoadingDetails = false
    state.isErrorDetails = false
  },

  [GET_CONTRACT_DETAIL_ERROR] (state, isErrorDetails) {
    state.isErrorDetails = isErrorDetails
    state.isLoadingDetails = false
  },

  [GET_SHIPMENT_ONGOING_LOADING] (state) {
    state.isLoadingOnGoing = true
    state.isErrorOnGoing = false
  },

  [GET_SHIPMENT_ONGOING_DONE] (state, OnGoing) {
    state.OnGoing = OnGoing
    state.isLoadingOnGoing = false
    state.isErrorOnGoing = false
  },

  [GET_SHIPMENT_ONGOING_ERROR] (state, isErrorOnGoing) {
    state.isErrorOnGoing = isErrorOnGoing
    state.isLoadingOnGoing = false
  },

  [EXTEND_CONTRACT_LOADING] (state) {
    state.itemExtend = false
    state.isLoadingExtend = true
  },

  [EXTEND_CONTRACT_DONE] (state, item) {
    state.itemExtend = true
    state.isLoadingExtend = false
  },

  [EXTEND_CONTRACT_ERROR] (state, error) {
    state.itemExtend = false
    state.errorExtend = true
    state.isLoadingExtend = false
  },

  [GET_BUSINESS_AGREEMENT_LOADING] (state) {
    state.itemBA = {}
    state.isLoadingBA = true
    state.errorBA = false
  },

  [GET_BUSINESS_AGREEMENT_DONE] (state, items) {
    state.itemBA = items
    state.isLoadingBA = false
    state.errorBA = false
  },

  [GET_BUSINESS_AGREEMENT_ERROR] (state, error) {
    state.itemBA = {}
    state.errorBA = true
    state.isLoadingBA = false
  },

  [ACCEPT_BUSINESS_AGREEMENT_LOADING] (state) {
    state.acceptBA = {}
    state.isLoadingAcceptBA = true
    state.errorAcceptBA = false
  },

  [ACCEPT_BUSINESS_AGREEMENT_DONE] (state, items) {
    state.acceptBA = items
    state.isLoadingAcceptBA = false
    state.errorAcceptBA = false
  },

  [ACCEPT_BUSINESS_AGREEMENT_ERROR] (state, error) {
    state.acceptBA = {}
    state.errorAcceptBA = true
    state.isLoadingAcceptBA = false
  },

  [DOWNLOAD_BUSINESS_AGREEMENT_LOADING] (state) {
    state.isLoadingDownloadBA = true
  },

  [DOWNLOAD_BUSINESS_AGREEMENT_DONE] (state, items) {
    state.isLoadingDownloadBA = false
  },

  [DOWNLOAD_BUSINESS_AGREEMENT_ERROR] (state, error) {
    state.errorDownloadBA = error
    state.isLoadingDownloadBA = false
  },

  [SHOW_AGREEMENT_CTC_LOADING] (state) {
    state.isLoadingAgreement = true
  },
  [SHOW_AGREEMENT_CTC_DONE] (state, items) {
    state.isShowAgreement = items
    state.isLoadingAgreement = false
  },
  [SHOW_AGREEMENT_CTC_ERROR] (state, error) {
    state.isErrDownloadAgreement = error
    state.isLoadingAgreement = false
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/contract/mutations.js